import type React from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Snackbar, SnackbarContent } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { useVersionCheck } from './util/useVersionCheck';

export const VersionChecker: React.FC = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    if (previousPathnameRef.current !== pathname && isNewVersionAvailable) {
      globalThis.location.reload();
    }
    previousPathnameRef.current = pathname;
  }, [isNewVersionAvailable, pathname]);

  const handleReload = () => {
    globalThis.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={isNewVersionAvailable}
    >
      <SnackbarContent
        action={
          <Button color="primary" onClick={handleReload} size="small" startIcon={<RefreshIcon />}>
            {t('common.refresh')}
          </Button>
        }
        message={t('common.newVersionAvailable')}
      />
    </Snackbar>
  );
};
